import parseDate from '@/lib/utils/news/utils';
import { getDesignationsWithData, buildSelectOptions } from '@/lib/utils/designation-overview/utils';

interface MenuItem {
  to: string;
  text: string;
  name: string;
  next?: MenuItem;
  childLinks?: MenuItem[];
}

interface Menu {
  array: MenuItem[];
  map: Record<string, MenuItem>;
}

interface Section {
  name: string;
  header: string;
}

interface Article {
  date: string;
  [key: string]: any;
}

interface DesignationOverviewData {
  physician: any;
  odmDesignationPhase: any;
  [key: string]: any;
}

interface DesignationOverviewResult {
  designations: any;
  selectOptions: any[];
  physician: any;
  odmDesignationPhase: any;
}

export default class DataModUtil {
  static convertPremiumMenu(data: any[]): Menu {
    const prefix = '/premium-methodology/';
    const map: Record<string, MenuItem> = {};

    const newsItem = {
      header: 'Premium Program News',
      name: 'premium-program-news',
      children: []
    };

    data.push(newsItem);

    const menuArray = data.map((parent, index, array) => {
      const p: MenuItem = {
        to: parent.to || `${prefix}${parent.name}`,
        text: parent.header,
        name: parent.name,
        next: parent.children[0] ? parent.children[0] : array[index + 1],
        childLinks: parent.children
          ? parent.children.map((child: any, childIndex: number, childArray: any[]) => {
            const c: MenuItem = {
              to: child.to || `${prefix}${child.name}`,
              text: child.header,
              name: child.name,
              next: childArray[childIndex + 1] || array[index + 1]
            };
            map[child.name] = c;
            return c;
          })
          : []
      };
      map[parent.name] = p;
      return p;
    });

    return {
      array: menuArray,
      map: map
    };
  }

  static convertFAQSections(data: Section[]): { to: string; text: string }[] {
    const path = '/help/faq/';
    return data.map(section => ({
      to: `${path}${section.name}`,
      text: section.header
    }));
  }

  static formatArticles(data: Article | Article[]): Article | Article[] {
    if (Array.isArray(data)) {
      return data.map(article => ({
        ...article,
        date: parseDate(article.date)
      }));
    }
    return {
      ...data,
      date: parseDate(data.date)
    };
  }

  static  getDesignationOverview(data: DesignationOverviewData): DesignationOverviewResult {
    const { physician, ...rest } = data;
    const designations = getDesignationsWithData(rest);
    const selectOptions = buildSelectOptions(designations);

    return {
      designations,
      selectOptions,
      physician,
      odmDesignationPhase: rest.odmDesignationPhase
    };
  }
}
